// @file Vuex plugin that listens/triggers changes in the address
import { Store } from 'vuex'
import { RootState } from '../surface/types'

const history = window.history

export default (store: Store<RootState>): void => {
  store.subscribe((mutation, state) => {
    if (!state.post.isInitialPaginatedDataLoadDone) return

    let newPathname = ''
    const getters = store.getters
    if (state.postAction.expandedPostCid) {
      newPathname = '/' + getters.address + '/wish/' + getters['postAction/expandedPostServerId']
      if (window.location.pathname !== newPathname) {
        history.pushState(
          {
            expandedPostCid: state.postAction.expandedPostCid,
            expandedPostServerId: getters['postAction/expandedPostServerId'],
          },
          '',
          newPathname,
        )
      }
    } else {
      if (state.isEmbedded) {
        newPathname = '/embed/' + getters.publicKey
      } else {
        newPathname = '/' + getters.address
      }
      if (window.location.pathname !== newPathname) {
        if (history.state && history.state.expandedPostServerId) {
          history.pushState({}, '', newPathname)
        } else {
          history.replaceState({}, '', newPathname)
        }
      }
    }
  })

  window.addEventListener('popstate', (e) => {
    const eventState = e.state
    if (eventState && eventState.expandedPostCid) {
      store.dispatch({
        type: 'postAction/expandPost',
        postCid: eventState.expandedPostCid,
        xTextPanel: true,
      })
    } else {
      store.dispatch({
        type: 'postAction/unexpandPost',
      })
    }
  })
}
